// extracted by mini-css-extract-plugin
export default {"modalAgregarPagoContainer":"EditarPagoComponent_modalAgregarPagoContainer__w-3Q7"};